import ax from '@utils/axios'
import { Auth } from '@utils/Auth'

function setLoginFailed(error) {
  console.error(error.response ? `Error Code: ${error.response.status}` : 'Unknown Error Code')
  if (error.response && error.response.status === 403) {
    this.errors.loginError = true
  }
  else {
    console.error(error)
    this.errors.connectionError = true
  }
}

async function stopImpersonation(params = {xhr: false}) {
  const url = '/admin/exit_impersonation_mode'
  if (! params.xhr ){
    window.location = url
  } else {
    const fullUrl = `${Auth.API_URL}${url}` // HACK: to strip the /api from axios base config
    await ax.get(fullUrl)
  }
}

export default {
  setLoginFailed,
  stopImpersonation,
}
